import * as React from "react";
import "./App.css";
import HomePage from "./pages/HomePage.tsx";

function App() {
  return <HomePage />;
}

export default App;
